module.exports = __webpack_public_path__ + "img/stock2.0f5375bd.png";